'use client'

import { ReactNode, useEffect } from 'react'
import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import Footer from './Footer'
import SiteLogo from './SiteLogo'
import ScreenReaderAnnouncements from '../ui/ScreenReaderAnnouncements'

// The banner (with its cookie inventory and animations) loads right after hydration instead of
// shipping in the critical bundle; it is a fixed overlay, so nothing shifts when it appears.
const CookieConsent = dynamic(() => import('../sections/CookieConsent'), { ssr: false })

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const pathname = usePathname()

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  // Hide cookie banner on the privacy page only. Paths are locale-prefixed
  // (/de/privacy, /fi/privacy), so match on the segment rather than an
  // exact/leading string.
  const isDatenschutzPage = pathname?.includes('/privacy') ?? false

  return (
    <div className="flex min-h-screen flex-col">
      <ScreenReaderAnnouncements />
      <main className="flex-1" id="main-content" role="main" tabIndex={-1}>
        <SiteLogo />
        {children}
      </main>
      <Footer />
      {!isDatenschutzPage && <CookieConsent />}
    </div>
  )
}
